

export const BarChartData = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],
    datasets: [{
        borderWidth: 2,
        borderColor: '#24695c',
        backgroundColor:'rgba(36, 105, 92, 0.4)',
        data: [35, 59, 80, 81, 56, 55, 40]
    }, {
        borderWidth: 2,
        borderColor: '#ba895d',
        backgroundColor:"rgba(186, 137, 93, 0.4)",
        data: [28, 48, 40, 19, 86, 27, 90]
    }]
};

export const BarChartOptions = {
  maintainAspectRatio: true,
  legend: {
    display: false,
  },
  plugins: {
    datalabels: {
      display: false,
    },
  },
  scales: {
      x: {
          grid: {
            offset: true
          }
      }
  }
};

export const LineGraphData = {
  labels: ["January", "February", "March", "April", "May", "June", "July"],
  datasets: [{
    fill: true,
    backgroundColor: 'rgba(36, 105, 92, 0.4)',
    tension: 0.5,
    borderColor: "#24695c",
    pointColor: "#24695c",
    pointBorderColor: "#fff",
    data: [10, 59, 80, 81, 56, 55, 40]
  },
  {
    fill: true,
    backgroundColor: 'rgba(186, 137, 93, 0.4)',
    tension: 0.5,
    borderColor: '#ba895d',
    pointColor: '#ba895d',
    pointBorderColor: "#fff",
    pointHighlightStroke: '#ba895d',
    data: [28, 48, 40, 19, 86, 27, 90]
  }
]
}

export const Radardata = {
  labels: ["Ford", "Chevy", "Toyota", "Honda", "Mazda"],
  datasets: [
    {
      fill:true,
      backgroundColor: "rgba(194, 116, 161, 0.5)",
      borderColor: "#24695c",
      pointBackgroundColor: 'rgba(36, 105, 92, 0.4)',
      pointBorderColor: "#24695c",
      pointHoverBackgroundColor: "#24695c",
      pointHoverBorderColor: 'rgba(145, 46, 252, 0.4)',
      data: [12, 3, 5, 18, 7]
    }
  ]
};

export const radarChartOptions = {
  scaleShowGridLines: true,
  scaleGridLineColor: "rgba(0,0,0,.2)",
  scaleGridLineWidth: 1,
  scaleShowHorizontalLines: true,
  scaleShowVerticalLines: true,
  bezierCurve: true,
  bezierCurveTension: 0.4,
  pointDot: true,
  pointDotRadius: 3,
  pointDotStrokeWidth: 1,
  pointHitDetectionRadius: 20,
  datasetStroke: true,
  datasetStrokeWidth: 2,
  datasetFill: true,
  legendTemplate: "<ul class=\"<%=name.toLowerCase()%>-legend\"><% for (var i=0; i<datasets.length; i++){%><li><span style=\"background-color:<%=datasets[i].strokeColor%>\"></span><%if(datasets[i].label){%><%=datasets[i].label%><%}%></li><%}%></ul>"
};

export const LineChartData = {
    labels: ["","10", "20", "30", "40", "50", "60", "70", "80"],
    datasets: [{
        backgroundColor: "rgba(113, 113, 113, 0.2)",
        borderColor: "#717171",
        pointColor: "#717171",
        data: [10, 20, 40, 30, 0, 20, 10, 30, 10]
    },{
        backgroundColor: "rgba(186, 137, 93, 0.2)",
        borderColor: '#ba895d',
        pointColor: '#ba895d',
        data: [20, 40, 10, 20, 40, 30, 40, 10, 20]
    }, {
        backgroundColor: "rgb(36, 105, 92, 0.2)",
        borderColor: '#24695c',
        pointColor: '#24695c',
        data: [60, 10, 40, 30, 80, 30, 20, 90, 0]
    }]
}

export const LineChart2option = {
  maintainAspectRatio: false,
  animation: {
    duration: 0
  },
  legend: {
    display: false,
  },
  scaleShowVerticalLines: false,
  plugins: {
    datalabels: {
      display: false,
      color: 'white'
    }
  }
}
export const DoughnutData ={ 
  datasets: [{
    data: [700, 100, 200],
    backgroundColor: ['#24695c', '#ba895d', "#222222"]
  }]
}

export const DoughnutOption = {
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  plugins: {
    datalabels: {
      display: false,
      color: 'white'
    }
  }
}
export const PolarData =  {
    datasets: [
    {
      data: [300, 50, 100, 40, 120],
      backgroundColor: ["#24695c", '#ba895d', "rgba(34,34,34,1)", "rgba(113, 113, 113, 1)", "#e2c636"]
    }
  ]
}


export const PolarOption = {
  legend: {
    display: false,
  }
}
